import React, { ComponentType, useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { AppState } from '@om-fe/core/core/types';

import { FavoriteTournamentsMenu as FavoriteTournamentsMenuV2 } from '@om-fe/widgets';
import { toggleRemoveFavoriteTournamentsAction } from '@om-fe/core/components/favorite-tournaments/V2/favorite-tournaments-button.actions';
import { useFavoriteTournamentStoreCreator } from '@om-fe/core/components/favorite-tournaments/V2/favorite-tournaments.actions';

interface FavoriteTournamentsMenuProps {
  	readonly widgetTitle: string;
  	readonly showDisciplineIcons: boolean;
  	readonly showItemIcons?: boolean;
  	readonly showSportName?: boolean;
  	readonly skipDisplayChild?: boolean;
  	readonly isEsportsPage?: boolean;
}

interface FavoriteTournamentsStoreProps {
  	readonly ready: boolean;
  	readonly list: string[];
}

interface FavoriteTournamentsDispatchProps {
  	readonly toggleFavoriteTournaments: typeof toggleRemoveFavoriteTournamentsAction;
}

export type FavoriteTournamentsProps = FavoriteTournamentsStoreProps 
	& FavoriteTournamentsDispatchProps
    & FavoriteTournamentsMenuProps;

function FavoriteTournamentsMenuComponent({
    widgetTitle,
    showDisciplineIcons,
    ready,
    list,
    toggleFavoriteTournaments,
    showItemIcons,
    showSportName,
    skipDisplayChild,
    isEsportsPage,
}: FavoriteTournamentsProps) {
  	const removeFavorite = useFavoriteTournamentStoreCreator('DELETE');
  	const updateFavortieTournament = useCallback((id: string) => {
      	toggleFavoriteTournaments(id, removeFavorite);
    },[removeFavorite, toggleFavoriteTournaments]);

  	if (!ready) {
    	return null;
  	}

  	return (
    	<FavoriteTournamentsMenuV2
      		widgetTitle={widgetTitle}
      		showDisciplineIcons={showDisciplineIcons}
      		layoutV2={true}
      		tournamentIds={list}
      		toggleFavoriteTournamentsAction={updateFavortieTournament}
      		showItemIcons={showItemIcons}
      		showSportName={showSportName}
      		skipDisplayChild={skipDisplayChild}
      		isEsportsPage={isEsportsPage}
    	/>
  	);
}

const FavoriteTournamentsMenu: ComponentType<FavoriteTournamentsMenuProps> = compose(
    connect<FavoriteTournamentsStoreProps, FavoriteTournamentsDispatchProps>(
        (state: AppState): FavoriteTournamentsStoreProps => {
            if (!state.favoriteTournaments) {
              	return {
                	ready: false,
                	list: [],
              	};
            }

            const { ready, list } = state.favoriteTournaments;

            return {
              	ready,
              	list,
            };
        },
		{
            toggleFavoriteTournaments: toggleRemoveFavoriteTournamentsAction
        }),
  	)(FavoriteTournamentsMenuComponent);

export default FavoriteTournamentsMenu;
